import type { ChangeEvent } from 'react'

import { Trans } from '@lingui/react'

import { Flex } from '@twisto/components/atoms/flex'
import { Slider } from '@twisto/components/atoms/slider'
import { Typography } from '@twisto/components/atoms/typography'
import { numberOfMonths } from '@twisto/locale'

import * as styles from './period-slider.styles'

type Props = {
  min: number
  max: number
  value: number
  onChange: (value: number) => void
}

export const PeriodSlider = ({ min, max, value, onChange }: Props) => (
  <Flex alignItems="center" direction="column">
    <Typography css={styles.title} fontWeight="medium" variant="b1">
      <Trans id="flow.components.installment.periodSlider.title" />
    </Typography>
    <Slider
      showLabel
      showValue
      labelFormatter={(value) => numberOfMonths(value)}
      max={max}
      min={min}
      name="installment-period"
      step={1}
      value={value}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        onChange(Number(event.target.value))
      }
    />
  </Flex>
)
